import React from "react";
import {BrowserRouter as Router, Routes, Route} from "react-router-dom";
import TagManager from 'react-gtm-module';

import HomePage from "./pages/HomePage";
import LevelPage from "./pages/LevelPage";
import Puzzle from "./pages/Puzzle";
import Test from "./pages/Test";

const tagManagerArgs = {
  gtmId: 'GTM-NR7L3MK'
}
TagManager.initialize(tagManagerArgs)

function App() {


  window.dataLayer.push({
    event: 'pageview'
  });

  return (
	 <Router basename="/apps/puzzles">
      <Routes>
          <Route exact path="/" element={<HomePage />} />
          <Route path="/level" element={<LevelPage />} />
          <Route path="/puzzle" element={<Puzzle />} />
          <Route path="/Test" element={<Test />} />
        </Routes>
    </Router>
  );
}


export default App;
